import { render, staticRenderFns } from "./Paso1View.vue?vue&type=template&id=0ff38ff4"
import script from "./Paso1View.vue?vue&type=script&lang=js"
export * from "./Paso1View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports